import React from 'react'
import { Box } from '@mui/material'
import type { MapData } from '@query/feature-query/common/map.query-string'
import { SectionHeader, SectionWrapper } from '@components/common'
import { getStyles } from '@utils/styles'
import defaultStyles from './styles'

export type MapSectionData = {
  mapData?: MapData
}

type MapSectionProp = MapSectionData & {
  showDivider?: 'bottom' | 'top' | 'both' | 'none'
  alternateSectionBg?: boolean
}

export function MapSection({
  mapData,
  showDivider,
  alternateSectionBg = false,
}: MapSectionProp) {
  const styles = getStyles(defaultStyles)

  const { url, sectionHeaderData, darkBg = false } = mapData || {}

  return (
    <SectionWrapper
      alternateBg={darkBg}
      showDivider={showDivider}
      alternateSectionBg={alternateSectionBg}
    >
      {sectionHeaderData && (
        <SectionHeader darkBg={darkBg} {...sectionHeaderData} />
      )}

      {url && (
        <Box {...styles('mapWrapper')}>
          <iframe
            title="Google Map"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            src={url}
            allowFullScreen
          />
        </Box>
      )}
    </SectionWrapper>
  )
}
